import { makeObservable, observable, computed, action } from "mobx";

import { userFlowState } from "/@/app/states/userFlowState.js";

export class StepState {
    api=null;
    xlsx_id;
    title;
    sound_link;
    benefit_years;
    informing_text;
    article_link;
    clinical_recommendation_1;
    clinical_recommendation_2;
    clinical_recommendation_3;
    status;
    order;
    //
    saveState = "ready";

    constructor(step, order, api) {
	this.api=api;
        // maybe make it automatic?..
	this.paywall_block=step.paywall_block;
	this.id=step.id
	this.subject=step.subject
        this.xlsx_id = step.xlsx_id;
        this.title = step.title;
        this.sound_link = step.sound_link;
        this.benefit_years = step.benefit_years;
        this.informing_text = step.informing_text;
        this.article_link = step.article_link;
        this.clinical_recommendation_1 = step.clinical_recommendation_1;
        this.clinical_recommendation_2 = step.clinical_recommendation_2;
        this.clinical_recommendation_3 = step.clinical_recommendation_3;
        this.status = step.status;
        //
        this.order = order;
        //

        makeObservable(this, {
            title: observable,
            sound_link: observable,
            benefit_years: observable,
            informing_text: observable,
            article_link: observable,
            clinical_recommendation_1: observable,
            clinical_recommendation_2: observable,
            clinical_recommendation_3: observable,
            //
            status: observable,
            saveState: observable,
            //
            setStatus: action,
            markDone: action,
            unMarkDone: action,
            //
            completable: computed,
        });
    }

    get completable() {
        return this.xlsx_id !== 59;  // псевдо-шаг ОПЖ
    }

    setStatus = (status) => {
        this.status = status;
    }
    setSaveState = (state) => {
        this.saveState = state;
    }

    markDone = () => {
        this.saveState = "saving";
        this.api.request(`cabinet/plan`, {'id':this.id,'subject':this.subject,'status':'complete'}, {api_url:'v2',method:'POST'})
	.then((data) => {
            this.setStatus('complete');
            this.setSaveState("ready");
        });
    }

    unMarkDone = () => {
        this.saveState = "saving";
        this.api.request(`cabinet/plan`, {'id':this.id,'subject':this.subject,'status':'new'}, {api_url:'v2',method:'POST'})
	.then((data) => {
            this.setStatus('new');
            this.setSaveState("ready");
        });
    }
}
